var _path, _path2, _path3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAz = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M0 85.337h512v113.775H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 312.888h512v113.775H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#f0f0f0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M259.2 297.6c-22.975 0-41.6-18.625-41.6-41.6s18.625-41.6 41.6-41.6a41.41 41.41 0 0119.789 5c-9.232-9.027-21.857-14.6-35.789-14.6-28.277 0-51.2 22.923-51.2 51.2s22.923 51.2 51.2 51.2c13.932 0 26.557-5.573 35.789-14.6a41.41 41.41 0 01-19.789 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.2 227.2l5.51 15.497 14.855-7.062-7.062 14.854L320 256l-15.497 5.511 7.062 14.854-14.855-7.062-5.51 15.497-5.51-15.497-14.855 7.062 7.062-14.854L262.4 256l15.497-5.511-7.062-14.854 14.855 7.062z"
}))));

export default SvgAz;